import { defineMessages, useIntl } from 'react-intl'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import Heading from 'LuxKit/Typography/Heading'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import ModalBase from 'LuxKit/Modal/ModalBase'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalFooter from 'LuxKit/Modal/ModalFooter'
import Group from 'components/utils/Group'

const messages = defineMessages({
  title: {
    id: 'S94SnfbCdOmMESZKCuVc',
    defaultMessage: 'Callback request error',
    description: 'Title for callback request warning modal when user already has a pending callback',
  },
  duplicateCallbackMessage: {
    id: 'rXz2hhJuWr9hjKCyUjm_',
    defaultMessage: 'You have already requested a callback. We’ll get back to you as soon as we can.',
    description: 'Warning message when user has already scheduled a callback',
  },
  closeButton: {
    id: '0EPxPE2sjYYL1YnqXBB6',
    defaultMessage: 'Close',
    description: 'Close/dismiss button for callback warning modal in a modal dialog',
  },
})

interface ContentProps {
  showTitle?: boolean
}

export function RequestAgentCallbackWarningContent(props: ContentProps) {
  const intl = useIntl()

  return (
    <VerticalSpacer gap={20}>
      {props.showTitle && (
        <Heading as="h2" variant="heading3">
          {intl.formatMessage(messages.title)}
        </Heading>
      )}
      <Group direction="vertical" gap={20}>
        <BodyTextBlock variant="large">
          {intl.formatMessage(messages.duplicateCallbackMessage)}
        </BodyTextBlock>
      </Group>
    </VerticalSpacer>
  )
}

export function RequestAgentCallbackWarningModal() {
  const intl = useIntl()

  return (
    <ModalBase>
      <form>
        <ModalHeader title={intl.formatMessage(messages.title)} />
        <ModalBody>
          <ModalContent>
            <RequestAgentCallbackWarningContent />
          </ModalContent>
        </ModalBody>
        <ModalFooter
          primaryActionProps={{
            children: intl.formatMessage(messages.closeButton),
          }}
        />
      </form>
    </ModalBase>
  )
}
